export const validateFileTypeAndSize = (file: File | null): boolean => {
  if (!file) return false;

  const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
  const maxSize = 3 * 1024 * 1024; // 3MB in bytes

  // Check file type
  if (!allowedTypes.includes(file.type)) {
    console.error("Invalid file type");
    alert("Please upload only JPG, JPEG or PNG images");
    return false;
  }
  // Check file size
  if (file.size > maxSize) {
    console.error("File size exceeds 3MB limit");
    alert("File size should not exceed 3MB");
    return false;
  }
  return true;
};
